export default {
    computed: {
        haveUnreadNotifications() {
            return Boolean(this.$store.getters.userNotifications.find(n => n.isRead === false));
        },
    },
};
